import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdateWidgetMutation } from "../graphql/mutations";
import type {
  UpdateWidgetMutationType,
  UpdateWidgetMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdateWidgetMutation = (
  options?: MutationHookOptions<
    UpdateWidgetMutationType,
    UpdateWidgetMutationVariablesType
  >
) => {
  return useMutation<
    UpdateWidgetMutationType,
    UpdateWidgetMutationVariablesType
  >(UpdateWidgetMutation, options);
};
